import MyTabs from '../../../components/MyTabs';
import Awards from './Awards';
import Screenings from './Screenings';


const Economics = () => {
  
    const tabs = [
        { id: "screenings", title: "Screenings", Component: Screenings },
        { id: "awards-honours", title: "Awards and Honours" , Component: Awards},
      ];

    return (
        <>
            <MyTabs list={tabs}/>
        </>
    )
};

export default Economics;